"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _style = _interopRequireDefault(require("./style.css"));
var _classnames = _interopRequireDefault(require("classnames"));
var _arrowRight = _interopRequireDefault(require("cccisd-icons/arrow-right20"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/** cccisd-hidden-block provides your with the block which shows up after clicking a link */
var _default = exports["default"] = /*#__PURE__*/function (_React$Component) {
  function _default() {
    var _this;
    _classCallCheck(this, _default);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, _default, [].concat(args));
    _defineProperty(_this, "state", {
      show: _this.props.show
    });
    _defineProperty(_this, "setShow", function (show) {
      _this.setState({
        show: show
      });
    });
    _defineProperty(_this, "_clicked", function (e) {
      e.preventDefault();
      _this.refs.link.blur();
      if (_this.props.handleClick) {
        _this.props.handleClick(!_this.props.show);
      } else {
        _this.setState({
          show: !_this.state.show
        });
      }
    });
    _defineProperty(_this, "_isShow", function () {
      if (_this.props.handleClick) {
        return _this.props.show;
      }
      return _this.state.show;
    });
    return _this;
  }
  _inherits(_default, _React$Component);
  return _createClass(_default, [{
    key: "render",
    value: function render() {
      var body = null;
      if (this._isShow()) {
        body = /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].body_wrapper
        }, this.props.children);
      }
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
        className: (0, _classnames["default"])(_style["default"].arrow_wrapper, this._isShow() && _style["default"].open)
      }, /*#__PURE__*/_react["default"].createElement(_arrowRight["default"], null)), /*#__PURE__*/_react["default"].createElement("a", {
        href: "#",
        onClick: this._clicked,
        className: _style["default"].link,
        ref: "link"
      }, this.props.title), this.props.comment, body);
    }
  }]);
}(_react["default"].Component);
_defineProperty(_default, "propTypes", {
  /** Title of the link */
  title: _propTypes["default"].node,
  /** Comment/text shown after link is clicked. */
  comment: _propTypes["default"].node,
  /** Show the hidden block or not. <br> This prop depends on the handleClick prop: <br> If handleClick is null then it will be the default value. <br> If handleClick is a function then it will be the actual value. */
  show: _propTypes["default"].bool,
  /** Callback function that runs when clicking the link. */
  handleClick: _propTypes["default"].func,
  children: _propTypes["default"].node
});
_defineProperty(_default, "defaultProps", {
  title: 'Hidden block',
  comment: null,
  show: false,
  handleClick: null
});